import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth6postPostScreenTruthAppsAppChromeApproveResponseSchema = jsonObject
export type tcpscreentruth6postPostScreenTruthAppsAppChromeApproveResponse = z.infer<typeof tcpscreentruth6postPostScreenTruthAppsAppChromeApproveResponseSchema>
export const tcpscreentruth6postPostScreenTruthScreensResponseSchema = jsonObject
export type tcpscreentruth6postPostScreenTruthScreensResponse = z.infer<typeof tcpscreentruth6postPostScreenTruthScreensResponseSchema>
